export const GET_MANAGER_STATUS_LIST = "GET_MANAGER_STATUS_LIST";
